import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

const Terms = () => {
  return (
    <>
      <Header />
      <section className="relative flex w-full bg-purple-800">
        <div className="container pt-[170px] pb-16 mx-auto ">
          <h1 class="title-font px-8 text-1xl md:text-2xl lg:text-3xl font-medium text-white leading-tight line-height-tight drop-shadow-lg">
            Terms &amp; Conditions
          </h1>
        </div>
      </section>

      <section class="text-gray-600 body-font">
        <div class="container px-5 py-12 mx-auto flex flex-wrap">
          <div className="text-base">
            <h1 className="text-2xl font-bold text-gray-900 py-8">
              Our agreements with you
            </h1>

            <p className="text-base mb-4">
              The following agreements will apply to you when you use our
              website, make an application for a loan or grant or use any of our
              services:
            </p>

            <ul className="max-w-md space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
              <li>
                <a
                  href="/terms/acceptable-use"
                  className="text-purple-600 hover:cursor-pointer"
                >
                  Acceptable Use Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms/privacy"
                  className="text-purple-600 hover:cursor-pointer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms/cookies"
                  className="text-purple-600 hover:cursor-pointer"
                >
                  Cookies &amp; Similar Technologies Policy
                </a>
              </li>
            </ul>

            <p className="text-sm mt-4 mb-4">
              These agreements do not directly relate to our lending products
              which have their own terms and conditions. If you wish to get a
              copy of any agreement you may have had with us in the past or
              currently, you can{" "}
              <a
                href="/contact"
                className="text-purple-600 hover:cursor-pointer"
              >
                contact us
              </a>
              .
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Terms;
